(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6725],{

/***/ 4569:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/[dining_id]",
      function () {
        return __webpack_require__(4878);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeroV2; }
/* harmony export */ });
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(870);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9180);
/* harmony import */ var swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_creative__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8352);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7239);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9735);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9741);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














function HeroV2(param1) {
    var heroItem = param1.heroItem, _hasFormNow = param1.hasFormNow, hasFormNow = _hasFormNow === void 0 ? false : _hasFormNow, height = param1.height;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), query = ref.query, isReady = ref.isReady;
    var bulletsRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var isLarge = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__/* .useLargeQuery */ .fc)().isLarge;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), sliderCaptions = ref1[0], setSliderCaptions = ref1[1];
    var id1 = heroItem.id, name = heroItem.name, banner = heroItem.banner, color_primary = heroItem.color_primary, hotel_code = heroItem.hotel_code, slider = heroItem.slider, is_parador = heroItem.is_parador, has_banner = heroItem.has_banner;
    var BannerHeading = _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q;
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        function f() {
            return _f.apply(this, arguments);
        }
        function _f() {
            _f = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
                var temp;
                return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            _ctx1.next = 2;
                            return Promise.all(slider.map(function() {
                                var _ref = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
                                    var id, x, y;
                                    return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                id = param.id;
                                                _ctx.next = 3;
                                                return (0,_utils_api__WEBPACK_IMPORTED_MODULE_11__/* .getWPImage */ .Mu)(id);
                                            case 3:
                                                x = _ctx.sent;
                                                _ctx.next = 6;
                                                return x.data.caption;
                                            case 6:
                                                y = _ctx.sent;
                                                if (y) {
                                                    y = y.rendered.replace("<p>", "").replace("</p>\n", "");
                                                }
                                                return _ctx.abrupt("return", y);
                                            case 9:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()));
                        case 2:
                            temp = _ctx1.sent;
                            setSliderCaptions(temp);
                        case 4:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1);
            }));
            return _f.apply(this, arguments);
        }
        f();
    }, [
        isReady
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
        className: "hero-container-v2",
        ref: containerRef,
        h: "800px",
        maxH: "800px",
        children: [
            !is_parador || has_banner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BannerHeading, {
                className: "banner",
                as: "h1",
                size: "lg",
                fontWeight: 300,
                letterSpacing: "widestx",
                textAlign: "center",
                children: banner
            }) : null,
            slider && slider.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .Swiper */ .tq, {
                lazy: true,
                centeredSlides: true,
                speed: 1000,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                loop: slider.length > 1,
                pagination: {
                    clickable: true
                },
                navigation: true,
                modules: slider.length > 1 ? [
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Autoplay */ .pt,
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl,
                    swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_
                ] : [],
                className: "mySwiper",
                onInit: function(swiper) {
                    if (slider.length > 1) {
                        swiper.navigation.init();
                        swiper.navigation.update();
                    }
                },
                children: slider && slider.map(function(image, i) {
                    var _i;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                            className: "image-container",
                            h: "800px",
                            width: "100%",
                            children: [
                                !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(sliderCaptions[i]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    className: "slider-caption",
                                    zIndex: 9,
                                    position: "absolute",
                                    fontWeight: 500,
                                    fontSize: [
                                        "x-small",
                                        "small"
                                    ],
                                    bottom: [
                                        "2px",
                                        "24px"
                                    ],
                                    opacity: [
                                        0.5,
                                        1
                                    ],
                                    right: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_13__/* .safeMarginX */ .Mp,
                                    color: "white",
                                    children: (_i = sliderCaptions[i]) !== null && _i !== void 0 ? _i : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    h: "100%",
                                    w: "100%",
                                    bg: is_parador && hasFormNow ? "blackAlpha.400" : "blackAlpha.700",
                                    zIndex: 5
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    className: "image-slider",
                                    src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_12__/* .convertImgHttps */ .Nu)(image.url),
                                    alt: "".concat(name, " slide ").concat(i + 1),
                                    layout: "fill",
                                    sizes: "(max-width: 640px) 100vw, (max-width: 1200px) 100vw, 100vw",
                                    priority: i === 0,
                                    quality: i === 0 ? 85 : 75,
                                    objectFit: "cover",
                                    loading: i === 0 ? "eager" : "lazy",
                                    unoptimized: true
                                })
                            ]
                        })
                    }, i);
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                h: "800px",
                bg: "gray.400"
            })
        ]
    });
};


/***/ }),

/***/ 2493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionGallery; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2879);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3955);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1914);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9735);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9741);
/* harmony import */ var _LoadingSpinner__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8506);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











function SectionGallery(param) {
    var _color = param.color, color = _color === void 0 ? "black" : _color, _limit = param.limit, limit = _limit === void 0 ? 4 : _limit, slug = param.slug, id = param.id, _type = param.type, type = _type === void 0 ? "hotels" : _type;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), data = ref2[0], setData = ref2[1];
    var ref3 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useFetchSWRv2 */ .bX)(type, {
        _ID: id,
        cct_status: "publish"
    }), 3), hotels = ref3[0], isLoading = ref3[1], isError = ref3[2];
    var limitParam = type == "dining" ? 4 : limit !== null && limit !== void 0 ? limit : 12;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(limitParam), limitCount = ref4[0], setLimitCount = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var temp;
        if (type == "hotels" && hotels && hotels[0].hotel_gallery && hotels[0].hotel_gallery.length > 0) {
            temp = _toConsumableArray(hotels[0].hotel_gallery);
            if (limitCount) {
                temp = temp.slice(0, limitCount);
            }
        } else if (type == "dining" && hotels && hotels[0].gallery && hotels[0].gallery.length > 0) {
            temp = _toConsumableArray(hotels[0].gallery);
            if (limitCount) {
                temp = temp.slice(0, limitCount);
            }
        }
        setData(temp);
    }, [
        hotels,
        limit,
        limitCount
    ]);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), imgSrc = ref6[0], setImgSrc = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isModalOpen = ref7[0], setIsModalOpen = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), photoIdx = ref8[0], setPhotoIdx = ref8[1];
    // useOutsideClick({
    //   ref: ref,
    //   handler: () => setIsModalOpen(false),
    // });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                bg: "white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                        mb: 2,
                        as: "h2",
                        fontWeight: 400,
                        letterSpacing: "wider",
                        color: color,
                        children: router.locale == "id" ? "Galeri" : "Gallery"
                    }),
                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingSpinner__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}) : data && data.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .SimpleGrid */ .MIq, {
                        columns: [
                            2,
                            3,
                            4
                        ],
                        spacing: [
                            4,
                            4,
                            6,
                            6,
                            8
                        ],
                        children: data.map(function(img, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .AspectRatio */ .oM5, {
                                ratio: 1,
                                bg: "".concat(color, "40"),
                                cursor: "pointer",
                                onClick: function() {
                                    setPhotoIdx(i);
                                    setImgSrc((0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .convertImgHttps */ .Nu)(img.url));
                                    setIsModalOpen(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                                    src: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_7__/* .convertImgHttps */ .Nu)(img.url),
                                    alt: "gallery image ".concat(i + 1),
                                    objectFit: "cover",
                                    h: "100%",
                                    w: "100%",
                                    loading: "lazy"
                                })
                            }, img.id);
                        })
                    }),
                    hotels && hotels.length > 0 && (hotels[0].hotel_gallery || hotels[0].gallery) && (limitCount < ((ref = hotels[0].hotel_gallery) === null || ref === void 0 ? void 0 : ref.length) || limitCount < ((ref1 = hotels[0].gallery) === null || ref1 === void 0 ? void 0 : ref1.length)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                        mt: limit == null ? _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_9__/* .safeMarginX */ .Mp : 0,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                            variant: "dark",
                            bg: color,
                            _hover: {
                                bg: "white",
                                color: color,
                                borderColor: color,
                                borderWidth: 1
                            },
                            borderColor: color,
                            onClick: function() {
                                if (limit == null) {
                                    setLimitCount(limitCount + (type == "dining" ? 4 : 12));
                                } else {
                                    router.push(slug ? "/".concat(slug, "/gallery") : "/gallery");
                                }
                            },
                            children: router.locale == "id" ? "Lebih Banyak" : "See More"
                        })
                    })
                ]
            }),
            isModalOpen && data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainSrc: data[photoIdx].url,
                nextSrc: data[(photoIdx + 1) % data.length],
                prevSrc: data[(photoIdx + data.length - 1) % data.length],
                onCloseRequest: function() {
                    return setIsModalOpen(false);
                },
                onMovePrevRequest: function() {
                    return setPhotoIdx((photoIdx + data.length - 1) % data.length);
                },
                onMoveNextRequest: function() {
                    return setPhotoIdx((photoIdx + 1) % data.length);
                }
            })
        ]
    });
};


/***/ }),

/***/ 4878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ DiningId; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/index.mjs + 808 modules
var dist = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-image-lightbox/style.css
var style = __webpack_require__(3955);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 101 modules
var swiper_esm = __webpack_require__(870);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(8352);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(155);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
// EXTERNAL MODULE: ./src/utils/mediaQuery.js
var mediaQuery = __webpack_require__(9741);
;// CONCATENATED MODULE: ./src/components/FlipBook.tsx







function FlipBook(param) {
    var link = param.link, isModalOpen = param.isModalOpen;
    var isLarge = (0,mediaQuery/* useLargeQuery */.fc)().isLarge;
    var modalRef = (0,react.useRef)(null);
    (0,dist/* useOutsideClick */.O3d)({
        ref: modalRef,
        handler: function() {
            return isModalOpen(false);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
        position: "fixed",
        w: "100vw",
        h: "100vh",
        bg: "blackAlpha.700",
        zIndex: 999,
        top: 0,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Center */.M5Y, {
            w: "100%",
            h: "100%",
            position: "relative",
            children: (0,lodash.isEmpty)(link) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                color: "white",
                children: "Not Found."
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        position: "absolute",
                        top: isLarge ? "5%" : "60px",
                        right: isLarge ? "12%" : "10px",
                        cursor: "pointer",
                        onClick: function() {
                            return isModalOpen(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoClose */.bjh, {
                            size: 24,
                            color: "white"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        ref: modalRef,
                        src: "https://flowpaper.com/flipbook/".concat((0,functions/* convertImgHttps */.Nu)(link)),
                        width: isLarge ? "70%" : "100%",
                        height: isLarge ? "90%" : "75%",
                        style: {
                            border: "none"
                        },
                        allowFullScreen: true
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/HeroV2.tsx
var HeroV2 = __webpack_require__(2699);
// EXTERNAL MODULE: ./src/layout/Section.jsx
var Section = __webpack_require__(1914);
;// CONCATENATED MODULE: ./src/components/SectionDetailInfo.jsx





function SectionDetailInfo(param) {
    var _color = param.color, color = _color === void 0 ? "black" : _color, _location = param.location, location = _location === void 0 ? "" : _location, _phone = param.phone, phone = _phone === void 0 ? "" : _phone, _hours = param.hours, hours = _hours === void 0 ? "" : _hours;
    var locale = (0,next_router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        variant: "zero",
        bg: "white",
        px: mediaQuery/* safeMarginX */.Mp,
        py: [
            10,
            20,
            30
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* SimpleGrid */.MIq, {
            columns: [
                2,
                3,
                4
            ],
            spacing: 10,
            color: "blackAlpha.800",
            fontSize: "sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                    mb: 2,
                    as: "h1",
                    fontWeight: 400,
                    letterSpacing: "wider",
                    color: color,
                    children: "Detail INFO"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                    h: "100%",
                    w: "100%",
                    pr: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                        children: location
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                    h: "100%",
                    w: "100%",
                    pr: 5,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Text */.xvT, {
                        children: [
                            "Tel : ",
                            phone
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Box */.xuv, {
                    h: "100%",
                    w: "100%",
                    pr: 5,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            children: locale == "id" ? "Jam Operasional:" : "Hours:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                            whiteSpace: "pre-line",
                            children: hours
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/SectionGallery.tsx
var SectionGallery = __webpack_require__(2493);
// EXTERNAL MODULE: ./src/containers/Helmet.tsx + 1 modules
var Helmet = __webpack_require__(9536);
// EXTERNAL MODULE: ./src/layout/FooterHotel.jsx
var FooterHotel = __webpack_require__(8078);
// EXTERNAL MODULE: ./src/layout/HeaderV3.tsx + 4 modules
var HeaderV3 = __webpack_require__(4850);
;// CONCATENATED MODULE: ./src/pages/dining/[dining_id].tsx



















var afterProp = {
    bottom: -1,
    content: '""',
    display: "block",
    height: "1px",
    left: "50%",
    position: "absolute",
    background: "white",
    transition: "all 0.3s ease 0s, left 0.3s ease 0s",
    width: 0
};
var hoverProp = {
    _after: {
        width: "100%",
        left: 0
    }
};
var __N_SSG = true;
function DiningId(param1) {
    var header = param1.header, hotelBrands = param1.hotelBrands, dining = param1.dining, hero = param1.hero;
    var onDocumentLoadSuccess = function onDocumentLoadSuccess(param) {
        var numPages = param.numPages;
        setNumPages(numPages);
    };
    var router = (0,next_router.useRouter)();
    var isLarge = (0,mediaQuery/* useLargeQuery */.fc)().isLarge;
    var ref15 = (0,react.useState)(0), headerHeight1 = ref15[0], setHeaderHeight = ref15[1];
    var color_primary = header.color_primary, slug = header.slug, id1 = header.id, location = header.location, phone = header.phone, logo_light = header.logo_light;
    var headline = dining.headline, subheadline = dining.subheadline, name = dining.name, hotel_name = dining.hotel_name, showcase = dining.showcase, id_showcase = dining.id_showcase, id_subheadline = dining.id_subheadline, en_subheadline = dining.en_subheadline, operational_hours = dining.operational_hours, operational_hours_id = dining.operational_hours_id;
    var toast = (0,dist/* useToast */.pmc)();
    var ref1 = (0,react.useState)(false), isModalOpen1 = ref1[0], setIsModalOpen = ref1[1];
    var reservationUrl = (0,react.useMemo)(function() {
        // 1. Direct URL dari field wa_dining di backend JetEngine CCT
        var backendWa = (dining === null || dining === void 0 ? void 0 : dining.wa_dining) || (dining === null || dining === void 0 ? void 0 : dining["wa-dining"]) || (dining === null || dining === void 0 ? void 0 : dining.wa_dinning) || (dining === null || dining === void 0 ? void 0 : dining["wa-dinning"]);
        if (backendWa && typeof backendWa === "string") {
            var trimmed = backendWa.trim();
            if (trimmed.startsWith("wa.me/")) {
                trimmed = "https://".concat(trimmed);
            }
            if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
                return trimmed;
            }
            var cleanNumber = trimmed.replace(/[^0-9]/g, "");
            if (cleanNumber.length > 0) {
                var internationalNumber = cleanNumber.startsWith("0") ? "62".concat(cleanNumber.slice(1)) : cleanNumber;
                return "https://wa.me/".concat(internationalNumber);
            }
        }
        // 2. Fallback jika field belum diisi
        return null;
    }, [
        dining
    ]);
    var handleReservation = function() {
        if (reservationUrl) {
            window.open(reservationUrl, "_blank", "noopener,noreferrer");
        } else {
            toast({
                title: router.locale === "id" ? "Layanan reservasi langsung belum tersedia" : "Direct reservation service is not available yet",
                description: router.locale === "id" ? "Silakan hubungi resepsionis hotel secara langsung." : "Please contact hotel reception directly.",
                status: "info",
                duration: 4000,
                isClosable: true
            });
        }
    };
    var ref2 = (0,react.useState)(0), photoIdx = ref2[0], setPhotoIdx = ref2[1];
    var ref3 = (0,react.useState)([]), brochures = ref3[0], setBrochures = ref3[1];
    (0,react.useEffect)(function() {
        setBrochures(Object.values((0,functions/* objParserWP */.aG)(dining.menu)[0]));
    }, [
        router.isReady
    ]);
    var ref4 = (0,react.useState)(null), numPages1 = ref4[0], setNumPages = ref4[1];
    var ref5 = (0,react.useState)(1), pageNumber = ref5[0], setPageNumber = ref5[1];
    var ref6 = (0,react.useState)(false), showSecondHeader = ref6[0], setShowSecondHeader = ref6[1];
    var ref7 = (0,react.useState)(""), navPosition = ref7[0], setNavPosition = ref7[1];
    var aboutRef = (0,react.useRef)(null);
    var galleryRef = (0,react.useRef)(null);
    var sectionRef = (0,react.useRef)(null);
    var ref8 = (0,react.useState)([]), heights = ref8[0], setHeights = ref8[1];
    (0,react.useEffect)(function() {
        var ref, ref11, ref12, ref13, ref14;
        if (!(aboutRef || galleryRef || sectionRef)) return;
        var temp = [];
        temp[0] = (ref = aboutRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        temp[1] = (ref11 = sectionRef.current) === null || ref11 === void 0 ? void 0 : ref11.clientHeight;
        temp[2] = (ref12 = sectionRef.current) === null || ref12 === void 0 ? void 0 : ref12.clientHeight;
        temp[3] = (ref13 = sectionRef.current) === null || ref13 === void 0 ? void 0 : ref13.clientHeight;
        temp[4] = (ref14 = galleryRef.current) === null || ref14 === void 0 ? void 0 : ref14.clientHeight;
        setHeights(temp);
    }, [
        aboutRef,
        galleryRef,
        sectionRef
    ]);
    var ref9 = (0,react.useState)(false), scrolling = ref9[0], setScrolling = ref9[1];
    var ref10 = (0,react.useState)(0), scrollTop = ref10[0], setScrollTop = ref10[1];
    (0,react.useEffect)(function() {
        var onScroll = function onScroll() {
            var ref, ref16;
            var currentPosition = window.pageYOffset; // or use document.documentElement.scrollTop;
            var screenH = window.innerHeight - 150;
            if (currentPosition < screenH) {
                setNavPosition("");
            } else if (currentPosition >= screenH && currentPosition < screenH + heights[0]) {
                setNavPosition("about");
            } else if (currentPosition >= screenH + heights[0] && currentPosition < screenH + heights[0] + heights[1]) {
                setNavPosition("eat");
            } else if (currentPosition >= screenH + heights[0] + heights[1] && currentPosition < screenH + heights[0] + heights[1] * 2) {
                setNavPosition("drink");
            } else if (currentPosition >= screenH + heights[0] + heights[1] * 2 && currentPosition < screenH + heights[0] + heights[1] * 3) {
                setNavPosition("promotion");
            } else if (currentPosition >= ((ref = galleryRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 150 && currentPosition < ((ref16 = galleryRef.current) === null || ref16 === void 0 ? void 0 : ref16.offsetTop) + heights[4] - 150) {
                setNavPosition("gallery");
            } else {
                setNavPosition("");
            }
        };
        if (!(heights.length > 0)) return;
        window.addEventListener("scroll", onScroll);
        return function() {
            return window.removeEventListener("scroll", onScroll);
        };
    }, [
        scrollTop,
        heights
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* default */.Z, {
                title: "".concat((0,lodash.capitalize)(name), " - Dining | ").concat((0,lodash.capitalize)(hotel_name), " | Parador Hotels & Resorts")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderV3/* default */.Z, {
                headerItem: header,
                isHomepage: true,
                hotelBrands: hotelBrands,
                isDining: true,
                getHeight: function(headerHeight) {
                    return setHeaderHeight(headerHeight);
                }
            }),
            isLarge && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                as: "div",
                h: "64px",
                position: "fixed",
                bg: header.color_primary,
                top: "60px",
                w: "100%",
                zIndex: 100,
                transition: "all 0.3s",
                className: "header-box-shadows",
                px: mediaQuery/* safeMarginX */.Mp,
                justify: "space-between",
                align: "center",
                fontSize: "small",
                fontWeight: 500,
                textTransform: "uppercase",
                color: "white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                        flex: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        flex: 5,
                        gap: 16,
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                opacity: navPosition == "about" ? 1 : 0.5,
                                cursor: "pointer",
                                position: "relative",
                                _after: afterProp,
                                _hover: hoverProp,
                                onClick: function() {
                                    var ref;
                                    window.scrollTo({
                                        top: ((ref = aboutRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 120,
                                        behavior: "smooth"
                                    });
                                },
                                children: router.locale == "id" ? "Tentang" : "About"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                opacity: navPosition == "eat" ? 1 : 0.5,
                                cursor: "pointer",
                                position: "relative",
                                _after: afterProp,
                                _hover: hoverProp,
                                onClick: function() {
                                    var ref;
                                    window.scrollTo({
                                        top: ((ref = aboutRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 80 + heights[0],
                                        behavior: "smooth"
                                    });
                                },
                                children: router.locale == "id" ? "Restoran" : "Eat"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                opacity: navPosition == "drink" ? 1 : 0.5,
                                cursor: "pointer",
                                position: "relative",
                                _after: afterProp,
                                _hover: hoverProp,
                                onClick: function() {
                                    var ref;
                                    window.scrollTo({
                                        top: ((ref = aboutRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) + heights[0] + heights[1],
                                        behavior: "smooth"
                                    });
                                },
                                children: router.locale == "id" ? "Minum" : "Drink"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                opacity: navPosition == "promotion" ? 1 : 0.5,
                                cursor: "pointer",
                                position: "relative",
                                _after: afterProp,
                                _hover: hoverProp,
                                onClick: function() {
                                    var ref;
                                    window.scrollTo({
                                        top: ((ref = aboutRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) + 60 + heights[0] + heights[1] * 2,
                                        behavior: "smooth"
                                    });
                                },
                                children: router.locale == "id" ? "Promosi" : "Promotion"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                opacity: navPosition == "gallery" ? 1 : 0.5,
                                cursor: "pointer",
                                position: "relative",
                                _after: afterProp,
                                _hover: hoverProp,
                                onClick: function() {
                                    var ref;
                                    window.scrollTo({
                                        top: ((ref = galleryRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 80,
                                        behavior: "smooth"
                                    });
                                },
                                children: router.locale == "id" ? "Galeri" : "Gallery"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                        flex: 1,
                        justify: "flex-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                            variant: "solid",
                            bg: "white",
                            color: header.color_primary,
                            onClick: handleReservation,
                            children: router.locale == "id" ? "RESERVASI MEJA" : "RESERVE"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroV2/* default */.Z, {
                hasFormNow: true,
                heroItem: hero,
                height: "calc(100vh - ".concat(headerHeight1, "px)")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Center */.M5Y, {
                p: mediaQuery/* safeMarginDesc */.nb,
                flexDirection: "column",
                gap: 6,
                ref: aboutRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                        as: "h1",
                        fontWeight: 400,
                        letterSpacing: "widest",
                        color: color_primary,
                        textAlign: "center",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                        maxW: {
                            base: "90%",
                            md: "50%"
                        },
                        align: "center",
                        children: router.locale == "id" ? id_subheadline : en_subheadline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                        display: {
                            base: "inline-flex",
                            lg: "none"
                        },
                        bg: color_primary,
                        color: "white",
                        _hover: {
                            opacity: 0.9
                        },
                        px: 8,
                        py: 4,
                        fontWeight: 500,
                        onClick: handleReservation,
                        children: router.locale == "id" ? "RESERVASI MEJA" : "RESERVE"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                px: mediaQuery/* safeMarginX */.Mp,
                py: mediaQuery/* safeMarginDesc */.nb,
                flexDir: "column",
                gap: 16,
                children: (0,functions/* objParserWP */.aG)(router.locale == "id" ? id_showcase : showcase).map(function(param2, i) {
                    var title = param2.title, desc = param2.desc, gallery = param2.gallery;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Flex */.kCb, {
                        ref: sectionRef,
                        flexDir: [
                            "column",
                            null,
                            i % 2 === 0 ? "row" : "row-reverse"
                        ],
                        gap: 12,
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                w: [
                                    "100%",
                                    null,
                                    "65%"
                                ],
                                h: [
                                    "50vh",
                                    null,
                                    "70vh"
                                ],
                                bg: "".concat(color_primary, "40"),
                                position: "relative",
                                className: "section-swiper-v2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    centeredSlides: true,
                                    loop: ((0,lodash.isString)(gallery) ? (0,functions/* strParser */.vP)(gallery) : gallery).length > 1,
                                    pagination: {
                                        clickable: true
                                    },
                                    autoplay: {
                                        delay: 8000,
                                        pauseOnMouseEnter: true,
                                        disableOnInteraction: true
                                    },
                                    modules: ((0,lodash.isString)(gallery) ? (0,functions/* strParser */.vP)(gallery) : gallery).length > 1 ? [
                                        swiper_esm/* Autoplay */.pt,
                                        swiper_esm/* Pagination */.tl
                                    ] : [],
                                    children: ((0,lodash.isString)(gallery) ? (0,functions/* strParser */.vP)(gallery) : gallery).map(function(param) {
                                        var url = param.url, id = param.id;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                                                w: "100%",
                                                h: "100%",
                                                position: "relative",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    alt: "",
                                                    src: (0,functions/* convertImgHttps */.Nu)(url),
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    priority: true,
                                                    unoptimized: true
                                                })
                                            })
                                        }, id);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Center */.M5Y, {
                                w: [
                                    "100%",
                                    null,
                                    "35%"
                                ],
                                flexDir: "column",
                                alignItems: "center",
                                textAlign: "center",
                                gap: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Heading */.X6q, {
                                        as: "h2",
                                        maxW: "70%",
                                        fontWeight: 500,
                                        letterSpacing: "wider",
                                        fontSize: "2xl",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Text */.xvT, {
                                        fontSize: {
                                            base: "sm",
                                            xl: "md"
                                        },
                                        maxW: [
                                            "70%",
                                            "100%"
                                        ],
                                        children: desc.replace(/\\/g, "")
                                    }),
                                    i === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                                bg: "white",
                                                border: "1.5px solid ".concat(color_primary),
                                                color: color_primary,
                                                // px={16}
                                                _hover: {
                                                    bg: color_primary,
                                                    color: "white"
                                                },
                                                w: 260,
                                                py: 4,
                                                fontWeight: 500,
                                                onClick: function() {
                                                    setIsModalOpen(true);
                                                    setPhotoIdx(0);
                                                },
                                                children: router.locale == "id" ? "menu all day" : "ALL DAY MENU"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                                bg: "white",
                                                border: "1.5px solid ".concat(color_primary),
                                                color: color_primary,
                                                // px={16}
                                                _hover: {
                                                    bg: color_primary,
                                                    color: "white"
                                                },
                                                w: 260,
                                                py: 4,
                                                fontWeight: 500,
                                                onClick: handleReservation,
                                                children: router.locale == "id" ? "RESERVASI MEJA" : "Book a Table"
                                            })
                                        ]
                                    }),
                                    i === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                        bg: "white",
                                        border: "1.5px solid ".concat(color_primary),
                                        color: color_primary,
                                        // px={16}
                                        _hover: {
                                            bg: color_primary,
                                            color: "white"
                                        },
                                        w: 260,
                                        py: 4,
                                        fontWeight: 500,
                                        onClick: function() {
                                            setIsModalOpen(true);
                                            setPhotoIdx(1);
                                        },
                                        children: router.locale == "id" ? "menu minuman" : "Drink menu"
                                    }),
                                    i === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                                        bg: "white",
                                        border: "1.5px solid ".concat(color_primary),
                                        color: color_primary,
                                        // px={16}
                                        _hover: {
                                            bg: color_primary,
                                            color: "white"
                                        },
                                        w: 260,
                                        py: 4,
                                        fontWeight: 500,
                                        onClick: function() {
                                            setIsModalOpen(true);
                                            setPhotoIdx(3);
                                        },
                                        children: router.locale == "id" ? "Promosi" : "Promotion"
                                    })
                                ]
                            })
                        ]
                    }, i);
                })
            }),
            isModalOpen1 && brochures.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlipBook, {
                link: brochures[photoIdx],
                isModalOpen: function(isModalOpen) {
                    return setIsModalOpen(isModalOpen);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                px: mediaQuery/* safeMarginX */.Mp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                    orientation: "horizontal",
                    borderColor: "blackAlpha.400"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Box */.xuv, {
                ref: galleryRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionGallery/* default */.Z, {
                    color: color_primary,
                    id: router.query.dining_id,
                    limit: null,
                    slug: slug,
                    type: "dining"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Flex */.kCb, {
                px: mediaQuery/* safeMarginX */.Mp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Divider */.izJ, {
                    orientation: "horizontal",
                    borderColor: "blackAlpha.400"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionDetailInfo, {
                color: color_primary,
                location: location,
                phone: phone,
                hours: router.locale == "id" ? operational_hours_id : operational_hours
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* Center */.M5Y, {
                mb: mediaQuery/* safeMarginY */.iM,
                flexDirection: {
                    base: "column",
                    sm: "row"
                },
                gap: 4,
                px: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                        w: {
                            base: "100%",
                            sm: "auto"
                        },
                        px: 8,
                        py: 5,
                        bg: color_primary,
                        color: "white",
                        borderColor: color_primary,
                        variant: "solid",
                        _hover: {
                            opacity: 0.9
                        },
                        onClick: handleReservation,
                        children: router.locale == "id" ? "Reservasi Meja" : "Reserve a Table"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Button */.zxk, {
                        w: {
                            base: "100%",
                            sm: "auto"
                        },
                        px: 8,
                        py: 5,
                        bg: "transparent",
                        color: color_primary,
                        border: "1px solid ".concat(color_primary),
                        _hover: {
                            color: "white",
                            bg: color_primary
                        },
                        onClick: function() {
                            return router.push("/".concat(slug, "/dining"));
                        },
                        children: router.locale == "id" ? "Kembali ke hotel restoran" : "Back to dining hotel"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterHotel/* default */.Z, {
                hotelSlug: header.slug,
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: color_primary,
                color: "white",
                logo: logo_light
            })
        ]
    });
};
function ColoredButton(param) {
    var _type = param.type, type = _type === void 0 ? "outline" : _type, children = param.children, _color = param.color, color = _color === void 0 ? "black" : _color, onClick = param.onClick;
    return /*#__PURE__*/ _jsx(Button, {
        bg: type === "outline" ? "white" : color,
        border: "1.5px solid ".concat(color),
        color: type === "outline" ? color : "white",
        // px={16}
        _hover: {
            bg: color,
            color: "white"
        },
        w: 260,
        py: 4,
        fontWeight: 500,
        children: children
    });
}


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ }),

/***/ 9180:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,6394,9392,4939,8078,9774,2888,179], function() { return __webpack_exec__(4569); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);